export const ORDER_CREATE = 'ORDER_CREATE'
export const ORDER_SUCCESS = 'ORDER_SUCCESS'
export const ORDER_ERROR = 'ORDER_ERROR'



// WEBPACK FOOTER //
// ./src/store/actions/order.js